import { createVuetify } from 'vuetify';
import * as directives from 'vuetify/directives';
import {
    VApp,
    VLayout,
    VAppBar,
    VForm,
    VTextField,
    VAppBarNavIcon,
    VAppBarTitle,
    VAvatar,
    VBtn,
    VContainer,
    VDivider,
    VIcon,
    VList,
    VListItem,
    VListItemSubtitle,
    VListItemTitle,
    VMain,
    VMenu,
    VNavigationDrawer,
    VSpacer,
    VCard,
    VCardText,
    VCardTitle,
    VCardActions,
    VImg,
    VRow,
    VCol,
    VSnackbar,
    VTable,
    VDialog,
    VSwitch,
    VSelect,
    VTooltip,
    VChip,
    VTreeview,
    VTextarea,
    VAutocomplete,
    VCombobox,
    VChipGroup,
    VListGroup,
    VSheet,
    VCheckbox,
    VFileInput,
    VBadge,
} from 'vuetify/components';
import { VDateInput } from 'vuetify/labs/VDateInput';
import { mdi } from 'vuetify/iconsets/mdi';
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';
import {
    cs, en, uk,
} from 'vuetify/locale';

const vuetify = createVuetify({
    directives,
    components: {
        VApp,
        VMain,
        VContainer,
        VAppBar,
        VBtn,
        VAppBarNavIcon,
        VAppBarTitle,
        VAvatar,
        VDivider,
        VIcon,
        VList,
        VListItem,
        VListItemTitle,
        VListItemSubtitle,
        VMenu,
        VNavigationDrawer,
        VSpacer,
        VCard,
        VCardText,
        VCardTitle,
        VCardActions,
        VForm,
        VTextField,
        VImg,
        VRow,
        VCol,
        VLayout,
        VSnackbar,
        VTable,
        VDialog,
        VSwitch,
        VSelect,
        VTooltip,
        VChip,
        VTreeview,
        VTextarea,
        VAutocomplete,
        VCombobox,
        VChipGroup,
        VListGroup,
        VSheet,
        VDateInput,
        VCheckbox,
        VFileInput,
        VBadge,
    },
    icons: {
        defaultSet: 'mdi',
        sets: { mdi },
    },
    locale: {
        locale: 'cs',
        fallback: 'cs',
        messages: { en, cs, uk },
    },
    theme: {
        defaultTheme: 'light',
        themes: {
            light: {
                colors: {
                    primary: '#62C5C7',
                    'primary-darken-1': '#4A9999',
                    'primary-lighten-1': '#8FCCCC',
                    'primary-light': '#f3ffff',
                    secondary: '#555555',
                    'secondary-lighten-1': '#777777',
                    'secondary-darken-1': '#333333',
                    success: '#1EA966',
                    'success-lighten-1': '#4EBA85',
                    'success-darken-1': '#167A4E',
                    warning: '#B18344',
                    'warning-lighten-1': '#C4986B',
                    'warning-darken-1': '#8A6434',
                    'warning-lighten-2': '#FC814A',
                    error: '#C0191E',
                    'error-lighten-1': '#D04449',
                    'error-darken-1': '#991317',
                    info: '#034692',
                    'info-lighten-1': '#2666A8',
                    'info-darken-1': '#023570',
                    accent: '#F14172',
                    'accent-lighten-1': '#F46B8F',
                    'accent-darken-1': '#C7335B',
                    'on-primary': '#FFFFFF',
                    'on-secondary': '#FFFFFF',
                    'on-surface': '#010101',
                    'on-background': '#010101',
                    background: '#ffffff',
                    'background-layout': '#F7FCFD',
                    surface: '#FFFFFF',
                    'surface-variant': '#D5CBA2',
                    outline: '#CCCCCC',
                    'outline-variant': '#E0E0E0',
                    'grey-25': '#FCFCFC',
                    'grey-50': '#FAFAFA',
                    'grey-100': '#F5F5F5',
                    'grey-200': '#EEEEEE',
                    'grey-300': '#E0E0E0',
                    'grey-400': '#BDBDBD',
                    'grey-500': '#9E9E9E',
                    'grey-600': '#757575',
                    'grey-700': '#616161',
                    'grey-800': '#424242',
                    'grey-900': '#212121',
                    'hover-bg': '#eef8ff',
                    'data-table-actions': '#808285',
                    'data-table-content': '#6D6E70',
                    'data-table-header': '#58595B',
                    'ai-red': '#EF4370',

                    // Dashboard accent colors
                    'accent-mint': '#5fd4c4',
                    'accent-mint-light': '#e8f8f5',
                    'accent-mint-dark': '#3dbdad',
                    'accent-purple': '#8b5cf6',
                    'accent-purple-light': '#f3f0ff',
                    'accent-orange': '#f59e0b',
                    'accent-orange-light': '#fef3c7',
                    'accent-pink': '#ec4899',
                    'accent-pink-light': '#fce7f3',
                    'accent-blue-dashboard': '#3b82f6',
                    'accent-blue-light': '#eff6ff',
                    'accent-green-dashboard': '#10b981',
                    'accent-green-light': '#ecfdf5',
                    'accent-red-dashboard': '#ef4444',
                    'accent-red-light': '#fef2f2',

                    // Skeleton colors for loading states
                    'skeleton-base': '#e8e8e8',
                    'skeleton-shine': '#f5f5f5',
                },
                variables: {
                    'sidebar-width': 254,
                    'sidebar-rail-width': 52,
                },
            },
        },
    },
});

export default vuetify;
